import React, { Suspense } from 'react'
import { styled } from '@creditas/stylitas'

import { GroupStatusLabel } from './GroupStatusLabel'
import { GroupStatusLabelContentFetching } from './GroupStatusLabelContentFetching'
import AdditionalInformation from './AdditionalInformation'
import { AssignmentDate } from './AssignmentDate'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

const LoanInfo: React.FC<{
  applicationId: string
  nextContact: Date | null
  pipelineStatus: string
  assignmentDate: Date | null
  cpf: string
}> = ({ nextContact, pipelineStatus, applicationId, assignmentDate, cpf }) => (
  <Container>
    <Suspense fallback={<GroupStatusLabelContentFetching />}>
      <GroupStatusLabel
        applicationId={applicationId}
        pipelineStatus={pipelineStatus}
        cpf={cpf}
      />
    </Suspense>
    <AdditionalInformation
      applicationId={applicationId}
      nextContact={nextContact}
    />
    <AssignmentDate date={assignmentDate} />
  </Container>
)

export { LoanInfo }
